import axios from 'axios';
import cfac22 from '../cfac22';
/**
 * Verifica o status do usuário em uma organização.
 * 
 * @param {string} uId - UID do usuário
 * @param {string} orgID - ID da organização
 * @returns {Promise<Object>} Retorna o status do usuário na organização
 * 
 * Regras de negócio:
 * - `participant`: usuário possui a org em sua lista E a org está publicada (isPublished !== false)
 * - `non-participant`: usuário não possui a org na lista, ou a org não está publicada
 * 
 * Nota: O status `pending` foi removido. Usuários antes considerados pendentes agora retornam `non-participant`.
 */
export async function getUserStatusOrgs(uId, orgID) {
  try {
    
    const response = await axios.get(
      `${cfac22('API_HOST_V2')}/organizations/user/status`,
      {
        params: {
          UID: uId,
          orgId: orgID,
        },
        headers: {
          'Full-Url': window.location.href,
        },
                withCredentials: true,

      }
    );
    
    return response.data;
  } catch (error) {
    throw error;
  }
}
